module.exports = __webpack_public_path__ + "static/media/foody.f57a47a5.gif";